import React from 'react';
import styles from './NFTSettingsPopupContent.module.scss';
import { useDispatch } from 'react-redux';
import { setIsTransferMode, setTranferList } from '@/store/app';

export const NFTCardSettingsPopupContent = ({
  nftData,
  setCardOnSale,
  toggleTransfer,
  toggleDrawer,
  availableBulkTransfer,
}) => {
  const dispatch = useDispatch();
  const toggleBulkTransfer = () => {
    dispatch(setIsTransferMode(true));
  };

  const menuItems = [
    {
      id: 0,
      label: nftData?.listing_id ? 'Remove from sale' : 'Put on sale',
      onClick: (event) => {
        event.preventDefault();
        setCardOnSale();
        toggleDrawer();
      },
      icon: '/svg/calendar.svg',
    },
    {
      id: 1,
      label: 'Transfer',
      onClick: (event) => {
        event.preventDefault();
        toggleTransfer();
        toggleDrawer();
      },
    },
    availableBulkTransfer
      ? {
          id: 2,
          label: 'Bulk Transfer',
          onClick: (event) => {
            event.preventDefault();
            toggleBulkTransfer();
            dispatch(setTranferList([nftData]));
            toggleDrawer();
          },
        }
      : null,
  ];

  const filteredItems = menuItems.filter((item) => {
    if (nftData?.live) return item.label !== 'Put on sale';
    return item;
  });

  return (
    <>
      {filteredItems
        .filter((item) => item)
        .map((item, index) => (
          <div
            className={styles.menuLabel}
            key={index}
            onClick={(event) => item.onClick(event)}
          >
            {item.label}
          </div>
        ))}
    </>
  );
};
